import { Injectable } from "@angular/core";
import { Headers, Http, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Rx";

export enum HttpVerb {
  Get,
  Post,
  Delete,
  Put,
  Patch
}

@Injectable()
export class BaseRestfulService<T> {
  private headers: Headers;
  private options: RequestOptions;

  constructor(protected _http: Http) {
    this.headers = new Headers();
    this.headers.append("Content-Type", "application/json; charset=utf-8");
    this.headers.append("Ocp-Apim-Subscription-Key", process.env.AppSettings.apimKey);
    this.options = new RequestOptions({ headers: this.headers });
  }

  protected callApiEndPoint(
    jsonData: T,
    apiEndPoint: string,
    verb: HttpVerb,
    jwt: string = null
  ): Observable<T> {
    let body = JSON.stringify(jsonData);
    let retVal: Observable<Response>;
    if (jwt != null) {
      this.options.headers.set("Authorization", jwt);
    }

    switch (verb) {
      case HttpVerb.Get:
        retVal = this._http.get(apiEndPoint, this.options);
        break;
      case HttpVerb.Post:
        retVal = this._http.post(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Delete:
        retVal = this._http.delete(apiEndPoint, this.options);
        break;
      case HttpVerb.Put:
        retVal = this._http.put(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Patch:
        retVal = this._http.patch(apiEndPoint, body, this.options);
    }
    return retVal.map(this.extractData).catch(this.handleError);
  }

  protected callApimEndPoint(
    returnType: T,
    apiEndPoint: string,
    verb: HttpVerb,
    data: string = null,
    jwt: string = null
  ): Observable<T> {
    if (jwt != null) {
      this.options.headers.set("Authorization", jwt);
    }
    else {
      this.options.withCredentials = true;
    }

    let body: string;
    if (data != null) {
      body = data;
    } else {
      body = JSON.stringify(returnType);
    }

    let retVal: Observable<Response>;

    switch (verb) {
      case HttpVerb.Get:
        retVal = this._http.get(apiEndPoint, this.options);
        break;
      case HttpVerb.Post:
        retVal = this._http.post(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Delete:
        retVal = this._http.delete(apiEndPoint, this.options);
        break;
      case HttpVerb.Put:
        retVal = this._http.put(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Patch:
        retVal = this._http.patch(apiEndPoint, body, this.options);
    }
    return retVal.map(this.extractData).catch(this.handleError);
  }

  protected callApiEndPoint2(
    jsonData: T,
    apiEndPoint: string,
    verb: HttpVerb,
    jwt: string = null
  ): Observable<T> {
    let body = JSON.stringify(jsonData);
    let retVal: Observable<Response>;
    if (jwt != null) {
      this.options.headers.set("Authorization", jwt);
    }

    switch (verb) {
      case HttpVerb.Get:
        retVal = this._http.get(apiEndPoint, this.options);
        break;
      case HttpVerb.Post:
        retVal = this._http.post(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Delete:
        retVal = this._http.delete(apiEndPoint, this.options);
        break;
      case HttpVerb.Put:
        retVal = this._http.put(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Patch:
        retVal = this._http.patch(apiEndPoint, body, this.options);
    }
    return retVal.map(this.extractData).catch(this.handleError2);
  }

  protected handleError2(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `"status": ${error.status}, "reason": "${error.statusText ||
        ""}", "error": ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(error.json());
  }

  protected handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

  protected extractData(res: Response) {
    let body = res.text() ? res.json() : {};
    let result = body ? body : body;
    return result;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/base-restful.service.ts